import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-fence-infos-angle-kit',
  templateUrl: './fence-infos-angle-kit.component.html',
})
export class FenceInfosAngleKitComponent {
  constructor(public modalService: ModalService) {}
}
